import { useMemo } from "react";
import { useAppContext } from "useAppContext";
import { getMultilingualString } from "shared/utils";
import { addressToAddressSearchValue } from "shared/components/organisms/SurveyQuestionInput/addressSearchResponse";
import type {
  DefaultContact,
  UserOperator,
} from "widgets/booker/contexts/BookerContextProvider/BookerContext";

/** Contact details and listings of the signed-in user, for prefilling the booker. */
export function useCurrentUserBookerPrefill(): {
  defaultContact: DefaultContact;
  userOperators: UserOperator[];
} {
  const { dbPerson, operators } = useAppContext();

  const defaultContact = useMemo(
    () => ({
      firstName: dbPerson?.firstName ?? "",
      lastName: dbPerson?.lastName ?? "",
      email: dbPerson?.email ?? "",
      phone: dbPerson?.phone ?? "",
      address: addressToAddressSearchValue(dbPerson?.address),
    }),
    [
      dbPerson?.firstName,
      dbPerson?.lastName,
      dbPerson?.email,
      dbPerson?.phone,
      dbPerson?.address,
    ],
  );

  const userOperators = useMemo(
    () =>
      (operators ?? []).map(op => ({
        entityId: op._entityId,
        name: getMultilingualString(op.name),
        organizationIds: (op.enrollments ?? [])
          .map(e => e?.organization?._id)
          .filter((id): id is string => !!id),
      })),
    [operators],
  );

  return { defaultContact, userOperators };
}
